import { useState } from "#imports";
export function useCookieConsent() {
  const state = useState("cookieConsent", () => ({
    necessary: true,
    functional: false,
    statistic: false,
    marketing: false,
    unclassified: false
  }));
  return {
    state,
    renew: cookieConsentRenew,
    show: cookieConsentShow
  };
}
export function cookieConsentRenew() {
  if (import.meta.client) {
    if (typeof window?.CookieScript?.instance?.show === "function") {
      window?.CookieScript?.instance?.show?.();
    } else {
      window?.CookieConsent?.renew?.();
    }
  }
}
export function cookieConsentShow() {
  if (import.meta.client) {
    if (typeof window?.CookieScript?.instance?.show === "function") {
      window?.CookieScript?.instance?.show?.();
    } else {
      window?.CookieConsent?.show?.();
    }
  }
}
